var map = {
	"./affordinginsurance.com/assets/img/logo.png": 6225,
	"./alcatrazblog.com/assets/img/logo.png": 7323,
	"./bestpropertyguides.net/assets/img/logo.png": 9903,
	"./dailyhistoryfacts.org/assets/img/logo.png": 8730,
	"./everydayhealthguide.net/assets/img/logo.png": 9766,
	"./financial-money.com/assets/img/logo.png": 1767,
	"./financialsinfo.com/assets/img/logo.png": 6923,
	"./findyourfit.net/assets/img/logo.png": 1158,
	"./jokeoftheday.info/assets/img/logo.png": 2371,
	"./newproductsforyou.com/assets/img/logo.png": 9993,
	"./savvyfinancetips.net/assets/img/logo.png": 1942,
	"./secretbeautydiscounts.com/assets/img/logo.png": 4593,
	"./sportshistory.info/assets/img/logo.png": 9297,
	"./template.com/assets/img/logo.png": 501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4268;